// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fY","advertDetailService__price":"c-p_fZ"};